import React, { useContext, useEffect, useState } from 'react';
import "../styles/assignDevice.css";
import {
    IonCard, IonChip,
    IonCol,
    IonContent,
    IonGrid,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
    IonButton, IonSpinner, IonPopover
} from "@ionic/react";
import { closeCircle, filterOutline, optionsOutline, search } from "ionicons/icons";
import { useHistory, useLocation } from "react-router";
import PaginatedView from "./PaginatedView";
import UserTable from "./UserTable";
import SubjectIdTable from "./SubjectIdTable";
import DeviceTable from "./DeviceTable";
import ChargerTable from "./ChargerTable";
import {
    handleGrantPolicy,
    getAllDevices,
    getAllUsers,
    getFilteredDevices,
    getFilteredUsers,
    handleRevokePolicy,
    getAllSubjects,
    handleGrantThingPolicy,
    getAllChargers,
    handlePairCharger
} from "../service/adminUI";
import AppContext from "./AppContext";
import SessionManager from '../service/SessionManager';
import { sendNotificationEmail } from '../service/notificationService';

import * as _ from "lodash";

import { syncTimerFreqMode } from "../util/config";
import { formatMacId } from "../utils/formatMacId";

const AssignDevice = props => {

    const { bckimgChange } = props;
    const history = useHistory();
    const location = useLocation();
    const [userResult, setUserResult] = useState([]);
    const [deviceResult, setDeviceResult] = useState([]);
    const [isUserDataLoading, setIsUserDataLoading] = useState(false);
    const [isSubjectDataLoading, setIsSubjectDataLoading] = useState(false);
    const [isDeviceDataLoading, setIsDeviceDataLoading] = useState(false);
    const [isAssigning, setIsAssigning] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const { appData, userData, userFilterData, deviceFilterData, setUserFilterData, setDeviceFilterData,
        userRecords, deviceRecords, setUserRecords, setDeviceRecords, dtalService } = useContext(AppContext);
    const MODEL_TYPE_USER = 'user';
    const MODEL_TYPE_DEVICE = 'device';
    const FILTER_CONDITION_ANY = 'or';
    const FILTER_CONDITION_ALL = 'and';
    const [userEmail, setUserEmail] = useState('');
    const [userType, setUserType] = useState('');
    const [userTypeSearch, setUserTypeSearch] = useState('');
    const [userTypeAsc, setUserTypeAsc] = useState('');
    const [deviceMacId, setDeviceMacId] = useState('');
    const [deviceNum, setDeviceNum] = useState('');
    const [userId, setUserId] = useState('');
    const [subjectId, setSubjectId] = useState('');

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [serialNo, setSerialNo] = useState('');
    const [macId, setMacId] = useState('');
    const [originalUserResult, setOriginalUserResult] = useState([]);
    const [originalDeviceResult, setOriginalDeviceResult] = useState([]);
    const [nameAsc, setNameAsc] = useState(true);
    const [emailAsc, setEmailAsc] = useState(true);
    const [serialNoAsc, setSerialNoAsc] = useState(true);
    const [macIdAsc, setMacIdAsc] = useState(true);
    const [toastClass, setToastClass] = useState('toast toast-invisible');
    const [toastVisible, setToastVisible] = useState(false);
    const [message, setMessage] = useState('Loading..Please wait');
    const TOAST_SUCCESS_CSS = 'toast toast-success';
    const TOAST_ERROR_CSS = 'toast toast-error';
    const TOAST_INFO_CSS = 'toast toast-info';

    const [subjectResult, setSubjectResult] = useState([]);

    // Charger search state
    const [chargerResult, setChargerResult] = useState([]);
    const [originalChargerResult, setOriginalChargerResult] = useState([]);
    const [chargerMacId, setChargerMacId] = useState('');
    const [chargerSerialNum, setChargerSerialNum] = useState('');
    const [chargerStatus, setChargerStatus] = useState('');
    const [chargerPairedIpg, setChargerPairedIpg] = useState('');
    const [isChargerDataLoading, setIsChargerDataLoading] = useState(false);
    const [isPairing, setIsPairing] = useState(false);
    const [chargerSerialFilter, setChargerSerialFilter] = useState('');
    const [chargerMacFilter, setChargerMacFilter] = useState('');

    // useEffect(async () => {
    //     bckimgChange('assignDevice.png');
    //     if (location.state) {
    //         const { modelType } = location.state;
    //         await handleLoadData(modelType);

    //         if (userRecords && userRecords.length > 0 && modelType != MODEL_TYPE_USER) {
    //             setUserResult(userRecords);
    //             setOriginalUserResult(userRecords);
    //         }
    //         if (deviceRecords && deviceRecords.length > 0 && modelType != MODEL_TYPE_DEVICE) {
    //             setDeviceResult(deviceRecords);
    //             setOriginalDeviceResult(deviceRecords);
    //         }
    //     }
    // }, [])

    const handleFilterOnClick = (modelName) => {
        history.push({ pathname: '/home/filter', state: { modelName } })
    }

    const handleLoadData = async (modelType) => {
        if (modelType === MODEL_TYPE_USER) {
            await handleLoadUsers();
        } else if (modelType === MODEL_TYPE_DEVICE) {
            await handleLoadDevices();
        } else {
            await handleLoadUsers();
            await handleLoadDevices();
        }
    }

    const handleAssignDevice = async () => {
        setIsAssigning(true);
        let patientSubjectId = '';
        let deviceData = {};
        let mapperData = {};
        let result = null;

        try {
            // Pre-validation before any policy is granted: a subject may be
            // linked to at most one device and at most one patient.
            if (userType === 'patient') {
                mapperData = await dtalService.get("mapper:" + userId);
                if (_.isEmpty(mapperData) || !mapperData[0]?.attributes?.subjectId) {
                    autoHideToast(TOAST_ERROR_CSS, `Assign failed: ${userEmail} has no subject mapped. Map a subject to the patient first.`);
                    return;
                }
                const mappedSubjectId = mapperData[0].attributes.subjectId;

                deviceData = await dtalService.get("pacemaker:" + deviceMacId);
                const deviceSubjectId = !_.isEmpty(deviceData) ? (deviceData[0].attributes?.subjectId ?? '') : '';
                if (deviceSubjectId && deviceSubjectId !== mappedSubjectId) {
                    autoHideToast(TOAST_ERROR_CSS, `Assign failed: Device ${deviceMacId} already belongs to subject ${deviceSubjectId}`);
                    return;
                }

                const devicesWithSubject = await dtalService.fetch("pacemaker", `eq(attributes/subjectId,"${mappedSubjectId}")`, 'thingId');
                const otherDevice = (devicesWithSubject?.items || []).find(t => t.thingId !== "pacemaker:" + deviceMacId);
                if (otherDevice) {
                    autoHideToast(TOAST_ERROR_CSS, `Assign failed: Subject ${mappedSubjectId} is already associated with device ${otherDevice.thingId.split(':')[1]}. A subject can only be linked to one device.`);
                    return;
                }
            }

            result = await handleGrantPolicy(deviceMacId, userId, SessionManager.getAccessToken(), userEmail, userType);
        /*         if(result.status==201){
                    autoHideToast(TOAST_SUCCESS_CSS, `Assign: ${result.message}` );
                } else if(result.status==204){
                    autoHideToast(TOAST_INFO_CSS, `Assign: ${result.message}` );
                } else{
                    autoHideToast(TOAST_ERROR_CSS, `Assign: ${result.message}`);
                } */

        if (result && ((result.status === 201) || (result.status === 204))) {
            sendNotificationEmail({
                type: 'device_assigned',
                to: userEmail,
                payload: {
                    deviceMacId,
                    deviceSerialNumber: deviceNum,
                },
            });
            try {
                //get subjectId associated with device
                deviceData = await dtalService.get("pacemaker:" + deviceMacId);
                if (!_.isEmpty(deviceData)) {
                    patientSubjectId = deviceData[0].attributes?.subjectId ?? '';
                }

                if (userType === 'patient') {
                    mapperData = await dtalService.get("mapper:" + userId);
                    if (_.isEmpty(mapperData) || !mapperData[0]?.attributes?.subjectId) {
                        autoHideToast(TOAST_ERROR_CSS, `Assign failed: ${userEmail} has no subject mapped. Map a subject to the patient first.`);
                        return;
                    }
                    let mappedSubjectId = mapperData[0].attributes?.subjectId ?? '';
                    if (patientSubjectId && patientSubjectId.length > 0 && patientSubjectId !== mappedSubjectId) {
                        autoHideToast(TOAST_ERROR_CSS, `Assign failed: Subject associated to device: ${deviceMacId}, is different from the subject already mapped to patient: ${mappedSubjectId}`);
                        return;
                    }
                    if (!patientSubjectId || patientSubjectId.length === 0) {
                        patientSubjectId = mappedSubjectId;
                        console.log(":::SubjectId found in mapper for the patient, adding that to device attributes:::");
                        let devicePayload = {
                            "attributes": {
                                "subjectId": patientSubjectId
                            }
                        };
                        await dtalService.patch("pacemaker:" + deviceMacId, devicePayload);
                        console.log(":::Device attributes updated with SubjectId:::");
                    }

                    //proceed further only if patient has subjectId
                    if (patientSubjectId.length > 0) {
                        let patientMessageAccessRights = {
                            policyowner: { userId: userData.userId, emailId: userData.emailId, type: userData.userType },
                            rwowners: [{ userId: userData.userId, emailId: userData.emailId, type: userData.userType }],
                            ronlyowners: [],
                        };
                        //Adding policyowner and rwowners to the patient message access rights
                        patientMessageAccessRights.rwowners.push({ userId: userId, emailId: userEmail, type: userType });
                        result = await dtalService.create("message:" + patientSubjectId + "-patient", {}, patientMessageAccessRights);
                        console.log(":::Message Policy created for Patient Message Stream:::", JSON.stringify(result));

                        //create symptom (access - RW)
                        let symptomAccessRights = {
                            policyowner: { userId: userData.userId, emailId: userData.emailId, type: userData.userType },
                            rwowners: [{ userId: userData.userId, emailId: userData.emailId, type: userData.userType }],
                            ronlyowners: [],
                        };
                        symptomAccessRights.ronlyowners = [];
                        symptomAccessRights.rwowners.push({ userId: userId, emailId: userEmail, type: userType });
                        await dtalService.create("symptom:" + patientSubjectId, {}, symptomAccessRights); //no symptom payload, to be triggered from patient app
                        autoHideToast(TOAST_SUCCESS_CSS, `Assign: Patient is Assigned to Device and Maaping  created successfully`);

                    } else {
                        autoHideToast(TOAST_ERROR_CSS, `Mapping failed: Patient is assigned the device but not mapped properly,${userEmail} has no subjectId found`);
                    }



                } else {
                    console.log(":::Doctor/Clinician path:::");
                    // //create message for Doctor, Patient assign Read                 
                    //proceed further only if device has subjectId
                    if (patientSubjectId.length > 0) {
                        console.log(":::SubjectId found in device attributes:::");

                        // accessRights.rwowners.push({ userId: userId, emailId: userEmail, type: userType });
                        // await dtalService.create("message:" + patientSubjectId, {}, accessRights);    
                        //grant Read only to doctor for patient message
                        await handleGrantThingPolicy('message:' + patientSubjectId + '-patient', userId, SessionManager.getAccessToken(), userEmail, userType, false);
                        console.log(":::Granted RW to doctor for patient message");
                        // grant R to doctor for patient symptom                         
                        await handleGrantThingPolicy('symptom:' + patientSubjectId, userId, SessionManager.getAccessToken(), userEmail, userType, false);

                        //grant RW to patient for doctor message, 
                        //fetch patient userId from subjectId 
                        mapperData = await dtalService.fetch("mapper", `eq(attributes/subjectId,"${patientSubjectId}")`, '');
                        if (!_.isEmpty(mapperData) && mapperData.items?.length > 0 && mapperData.items[0]?.attributes?.emailId) {
                            console.log(":::Patient EmailId found for the Subject Selected:::");
                            let patientUserId = mapperData.items[0].thingId.split(':')[1];
                            let patientEmailId = mapperData.items[0].attributes.emailId;
                            let patientType = mapperData.items[0].attributes.type; //mostly this will be always 'patient'

                            // Creating Message Policy for Clinicians Message Stream
                            let accessRights = {
                                //give policy RW and thing RW to logged in admin user credentials
                                policyowner: { userId: userData.userId, emailId: userData.emailId, type: userData.userType },
                                rwowners: [{ userId: userData.userId, emailId: userData.emailId, type: userData.userType }],
                                ronlyowners: [],
                            };
                            accessRights.rwowners.push({ userId: userId, emailId: userEmail, type: userType });
                            accessRights.ronlyowners.push({ userId: patientUserId, emailId: patientEmailId, type: patientType });
                            await dtalService.create("message:" + patientSubjectId, {}, accessRights);
                            console.log(":::Message Policy created for Clinicians Message Stream:::");
                            //await handleGrantThingPolicy('message:' + userId, patientUserId, SessionManager.getAccessToken(), patientEmailId, patientType, true);

                            //create syncTimer (access -RW for doctor, R for patient),   
                            let syncTimerAccessRights = {
                                policyowner: { userId: userData.userId, emailId: userData.emailId, type: userData.userType },
                                rwowners: [{ userId: userData.userId, emailId: userData.emailId, type: userData.userType }],
                                ronlyowners: [],
                            };
                            syncTimerAccessRights.ronlyowners = [];
                            syncTimerAccessRights.rwowners.push({ userId: userId, emailId: userEmail, type: userType });
                            syncTimerAccessRights.ronlyowners.push({ userId: patientUserId, emailId: patientEmailId, type: patientType });

                            //fetch eCRF_implant 
                            let triggerTimeStamp = 0;
                            let implantRecord = await dtalService.get('eCRF_implant:' + patientSubjectId);
                            if (!_.isEmpty(implantRecord)) {
                                //ZZZZ depends on how the eCRF data is saved in RMS
                                //if(implantRecord.items[0].features.content.properties.)
                            }
                            // Get today's date
                            const today = new Date();
                            // Get current year
                            const year = today.getFullYear();
                            // Get current month(0 based)
                            const month = today.getMonth();
                            // Keep day as 1 to get first day
                            const day = 1;
                            // Get first day of current month
                            const firstDayOfMonth = new Date(year, month, day);
                            triggerTimeStamp = firstDayOfMonth.getTime() / 1000;

                            let syncTimerPayload = {
                                "features": {
                                    "content": {
                                        "properties": {
                                            "triggerTimeStamp": triggerTimeStamp,
                                            "freqmode": syncTimerFreqMode
                                        }
                                    }
                                }

                            }
                            await dtalService.create("syncTimer:" + patientSubjectId, syncTimerPayload, syncTimerAccessRights); //no symptom payload, to be triggered from patient app                     
                            autoHideToast(TOAST_SUCCESS_CSS, `Assign: Device assigned successfully`);
                        }
                        else {
                            autoHideToast(TOAST_ERROR_CSS, `Assign: Failed as SubjectId is not mapped to the device`);
                        }
                    } else {
                        autoHideToast(TOAST_ERROR_CSS, `Assign: failed as device ${deviceMacId} has no subjectId associated`);
                    }


                }

            } catch (e) {
                console.log(e);
                autoHideToast(TOAST_ERROR_CSS, `Assign: ${result?.message || 'An error occurred during assignment'}`);
            }

            //create message, assign Read

            //if patient, update device-attirbutes with subjectId, create symptom (access - RW)

            //if doctor/physician, assign RW to patient message, assign RW to doctor message, 
            //create syncTimer (access -RW for doctor, R for patient), assign R to patient symptom
        } else {
            // Policy assignment failed
            autoHideToast(TOAST_ERROR_CSS, `Assign: ${result?.message || 'Failed to assign policy'}`);
        }
        } catch (error) {
            console.error('Error in handleAssignDevice:', error);
            autoHideToast(TOAST_ERROR_CSS, `Assign: ${error.message || 'An error occurred during assignment'}`);
        } finally {
            setIsAssigning(false);
        }
    }

    const handleUnAssignDevice = async () => {
        const result = await handleRevokePolicy(deviceMacId, userId, SessionManager.getAccessToken(), userEmail, userType);
        if (result.status === 204) {
            autoHideToast(TOAST_SUCCESS_CSS, `UnAssign: ${result.message}`);
        }
        else {
            autoHideToast(TOAST_ERROR_CSS, `UnAssign: ${result.message}`);
        }
    }

    const handleMapSubject = async () => {
        //create a mapper entry btw patient and subjectId
        let accessRights = {
            //get the logged in admin user credentials
            policyowner: { userId: userData.userId, emailId: userData.emailId, type: userData.userType },
            rwowners: [{ userId: userData.userId, emailId: userData.emailId, type: userData.userType }],
            ronlyowners: [],
        };
        //form userId + subjectId mapper payload
        let mapperPayload = {
            "attributes": {
                "subjectId": subjectId,
                "emailId": userEmail,
                "type": userType
            }
        };
        try {
            // A subject may be mapped to only one patient at a time.
            const existingMaps = await dtalService.fetch("mapper", `eq(attributes/subjectId,"${subjectId}")`, '');
            const otherPatient = (existingMaps?.items || []).find(m => m.thingId !== "mapper:" + userId);
            if (otherPatient) {
                autoHideToast(TOAST_ERROR_CSS, `Mapping failed: Subject ${subjectId} is already mapped to patient ${otherPatient.attributes?.emailId || otherPatient.thingId.split(':')[1]}. Unmap it first.`);
                return;
            }

            // A patient may hold only one subject — block silent remapping.
            const currentMap = await dtalService.get("mapper:" + userId);
            if (!_.isEmpty(currentMap) && currentMap[0]?.attributes?.subjectId && currentMap[0].attributes.subjectId !== subjectId) {
                autoHideToast(TOAST_ERROR_CSS, `Mapping failed: ${userEmail} is already mapped to subject ${currentMap[0].attributes.subjectId}. Unmap it before assigning a new subject.`);
                return;
            }

            //create an mapper thing with id as userId and containing static attribute subjectId
            await dtalService.create("mapper:" + userId, mapperPayload, accessRights);

            autoHideToast(TOAST_SUCCESS_CSS, `Mapped subject ${subjectId} to patient ${userEmail}`);

        } catch (e) {
            console.log(e);
            autoHideToast(TOAST_ERROR_CSS, `Mapping failed subject ${subjectId} to patient ${userEmail}`);
        }

    }
    const handleLoadUsers = async (isStaleExpression) => {
        let fetchedUsers = null;
        let newUserExpression = '';
        setUserId('');
        setUserEmail('');
        setUserType('');
        setUserTypeSearch('');
        setIsUserDataLoading(true);

        try {
            if (isStaleExpression === true) {
                newUserExpression = setFilterExpression(MODEL_TYPE_USER)
            } else {
                newUserExpression = userFilterData.userFilterExpression;
            }
            if (userFilterData.userFilters && !(userFilterData.userFilters.length > 0)) {
                fetchedUsers = await getAllUsers(SessionManager.getAccessToken());
            } else {
                //await getFilteredUsers(SessionManager.getAccessToken(), 'clarity');
                fetchedUsers = await getFilteredUsers(SessionManager.getAccessToken(), newUserExpression);
            }
            if (fetchedUsers && fetchedUsers.length > 0) {
                  const list = Array.isArray(fetchedUsers) ? fetchedUsers : [];
                  let Users = list.filter(u => (u?.attributes?.type?.[0] || '').toLowerCase() !== 'admin');
                  // Filter by active site if set
                  if (userData.activeSiteId) {
                      Users = Users.filter(u => u.attributes?.sites?.includes(userData.activeSiteId));
                  }
                  setUserResult(Users);
                  setOriginalUserResult(Users);
                  setUserRecords(Users);
            } else {
                setUserRecords([]);
                autoHideToast(TOAST_INFO_CSS, "Users search: No data received");
            }
        } catch (error) {
            console.error('Failed to load users:', error);
            setUserRecords([]);
            if (error.message?.includes('Failed to fetch') || error.message?.includes('CORS')) {
                autoHideToast(TOAST_ERROR_CSS, "Users search failed: CORS/Network error");
            } else if (error.message?.includes('401') || error.message?.includes('Unauthorized')) {
                autoHideToast(TOAST_ERROR_CSS, "Users search failed: Authentication required");
            } else {
                autoHideToast(TOAST_ERROR_CSS, "Users search failed: " + error.message);
            }
        }
        setIsUserDataLoading(false);
    }

    const handleLoadSubjects = async () => {
        let subjectData = null;
        setIsSubjectDataLoading(true);
        subjectData = await getAllSubjects(SessionManager.getAccessToken(), userData.activeSiteId || '');
        if (subjectData && subjectData.length > 0) {
            setSubjectResult(subjectData);
        } else {
            setSubjectResult([]);
            autoHideToast(TOAST_INFO_CSS, "Subjects search: No data received");
        }
        setIsSubjectDataLoading(false);
    }

    const handleLoadDevices = async (isStaleExpression) => {
        let deviceData = null;
        let newDeviceExpression = '';
        setDeviceMacId('');
        setIsDeviceDataLoading(true);
        if (isStaleExpression === true) {
            newDeviceExpression = setFilterExpression(MODEL_TYPE_DEVICE)
        } else {
            newDeviceExpression = deviceFilterData.deviceFilterExpression;
        }
        if (deviceFilterData.deviceFilters && !(deviceFilterData.deviceFilters.length > 0)) {
            deviceData = await getAllDevices(SessionManager.getAccessToken());
        } else {
            //await getFilteredDevices(appData.accessToken, 'eq(attributes/serialnumber,"AAA089010AAB")');
            deviceData = await getFilteredDevices(SessionManager.getAccessToken(), newDeviceExpression);
        }
        if (deviceData && deviceData.length > 0) {
            setDeviceResult(deviceData);
            setOriginalDeviceResult(deviceData);
            setDeviceRecords(deviceData);
        } else {
            setDeviceRecords([]);
            autoHideToast(TOAST_INFO_CSS, "Devices search: No data received");
        }
        setIsDeviceDataLoading(false);
    }

    const handleLoadChargers = async () => {
        setChargerMacId('');
        setChargerSerialNum('');
        setIsChargerDataLoading(true);
        try {
            const chargerData = await getAllChargers(SessionManager.getAccessToken());
            if (chargerData && chargerData.length > 0) {
                setChargerResult(chargerData);
                setOriginalChargerResult(chargerData);
            } else {
                setChargerResult([]);
                setOriginalChargerResult([]);
                autoHideToast(TOAST_INFO_CSS, "Chargers search: No data received");
            }
        } catch (error) {
            console.error('Failed to load chargers:', error);
            setChargerResult([]);
            autoHideToast(TOAST_ERROR_CSS, "Chargers search failed: " + error.message);
        }
        setIsChargerDataLoading(false);
    }

    const handleChargerOnChange = event => {
        const data = JSON.parse(event.currentTarget.value);
        setChargerMacId(data.macid);
        setChargerSerialNum(data.serialnumber);
        setChargerStatus(data.status || '');
        setChargerPairedIpg(data.pairedIpgMacId || '');
    }

    const handleChargerSerialFilter = event => {
        const value = event.currentTarget.value;
        setChargerSerialFilter(value);
        const data = originalChargerResult.filter(c => c.attributes.serialNumber && c.attributes.serialNumber.toLowerCase().includes(value.toLowerCase()));
        setChargerResult(data);
    }

    const handleChargerMacFilter = event => {
        const value = event.currentTarget.value;
        setChargerMacFilter(value);
        const data = originalChargerResult.filter(c => c.attributes.macId && c.attributes.macId.toLowerCase().includes(value.toLowerCase()));
        setChargerResult(data);
    }

    const handleAssignCharger = async () => {
        if (chargerStatus === 'paired' && chargerPairedIpg) {
            const confirmed = window.confirm(
                `Charger ${chargerMacId} is currently paired with IPG ${chargerPairedIpg}.\n\nRe-pairing will replace the existing IPG assignment. Continue?`
            );
            if (!confirmed) return;
        }
        setIsPairing(true);
        try {
            const result = await handlePairCharger(chargerMacId, deviceMacId, SessionManager.getAccessToken());
            if (result.success) {
                autoHideToast(TOAST_SUCCESS_CSS, `Charger ${chargerMacId} paired with device ${deviceMacId} successfully`);
            } else {
                autoHideToast(TOAST_ERROR_CSS, `Pair failed: ${result.error || 'Unknown error'}`);
            }
        } catch (error) {
            console.error('Error pairing charger:', error);
            autoHideToast(TOAST_ERROR_CSS, `Pair failed: ${error.message}`);
        }
        setIsPairing(false);
    }

    const setFilterExpression = (model) => {
        let filterExpression = '';
        let filters = null;
        model === MODEL_TYPE_USER ? (filters = userFilterData.userFilters) : (filters = deviceFilterData.deviceFilters);

        //get all data when no filter selected
        if (filters === null || !(filters.length > 0)) {
            filterExpression = '';
        } else {
            if (filters.length === 1) {
                // no prefix for single expression
                filterExpression = filters[0].id;
            } else {
                for (let i = 0; i < filters.length; i++) {
                    filterExpression = `${filterExpression}${filters[i].id},`;
                }
                filterExpression = filterExpression.slice(0, -1);
                if (model === MODEL_TYPE_USER) {
                    //append and-or condition prefix in expression
                    filterExpression = (userFilterData.userFilterExpression.startsWith(FILTER_CONDITION_ANY) ?
                        FILTER_CONDITION_ANY : FILTER_CONDITION_ALL) + `(${filterExpression})`;
                } else if (model === MODEL_TYPE_DEVICE) {
                    //append and-or condition prefix in expression
                    filterExpression = (deviceFilterData.deviceFilterExpression.startsWith(FILTER_CONDITION_ANY) ?
                        FILTER_CONDITION_ANY : FILTER_CONDITION_ALL) + `(${filterExpression})`;
                }
            }
        }
        //set app context for the filters and expressions
        model === MODEL_TYPE_USER ?
            (setUserFilterData({ ...userFilterData, userFilterExpression: filterExpression })) :
            (setDeviceFilterData({ ...deviceFilterData, deviceFilterExpression: filterExpression }));
        return filterExpression;
    }


    const handleDeleteFilter = (chipToDelete, model) => () => {
        if (model === MODEL_TYPE_USER) {
            const chips = userFilterData.userFilters;
            setUserFilterData({
                ...userFilterData,
                userFilters: [...chips.filter((chip) => chip.key !== chipToDelete.key)]
            });
        } else if (model === MODEL_TYPE_DEVICE) {
            const chips = deviceFilterData.deviceFilters;
            setDeviceFilterData({
                ...deviceFilterData,
                deviceFilters: [...chips.filter((chip) => chip.key !== chipToDelete.key)]
            });
        }
    }

    const handleUserOnChange = event => {
        const data = JSON.parse(event.currentTarget.value);
        setUserEmail(data.email);
        setUserType(data.type);
        setUserId(data.id);
    }

    const handleSubjectOnChange = event => {
        const data = event.currentTarget.value;
        if (data) setSubjectId(data);
    }

    const handleDeviceOnChange = event => {
        const data = JSON.parse(event.currentTarget.value);
        setDeviceMacId(data.macid);
        setDeviceNum(data.serialnumber);
    }

    const handleNameOnChange = event => {
        const value = event.currentTarget.value;
        setName(value);
        const data = originalUserResult.filter(user => (user.firstName && user.firstName.toLowerCase().includes(value.toLowerCase())) || (user.lastName && user.lastName.toLowerCase().includes(value.toLowerCase())));
        setUserResult(data);
    }

    const handleEmailOnChange = event => {
        const value = event.currentTarget.value;
        setEmail(value);
        const data = originalUserResult.filter(user => user.email && user.email.toLowerCase().includes(value.toLowerCase()));
        setUserResult(data);
    }

    const handleUserTypeSearch = event => {
        const value = event.currentTarget.value;
        setUserTypeSearch(value);
        const data = originalUserResult.filter(user => user.attributes.type[0] && user.attributes.type[0].toLowerCase().includes(value.toLowerCase()));
        setUserResult(data);
    }

    const handleSerialNoOnChange = event => {
        const value = event.currentTarget.value;
        setSerialNo(value);
        const data = originalDeviceResult.filter(device => device.attributes.serialnumber.includes(value));
        setDeviceResult(data);
    }

    const handleMacIdOnChange = event => {
        const value = formatMacId(event.currentTarget.value);
        setMacId(value);
        const data = originalDeviceResult.filter(device => device.attributes.macid.toLowerCase().includes(value.toLowerCase()));
        setDeviceResult(data);
    }

    const handleNameIconOnClick = () => {
        let data;
        if (nameAsc) {
            data = userResult.sort((a, b) => (a.firstName + " " + a.lastName).localeCompare(b.firstName + " " + b.lastName));
        } else {
            data = userResult.sort((a, b) => (b.firstName + " " + b.lastName).localeCompare(a.firstName + " " + a.lastName));
        }
        setNameAsc(!nameAsc);
        setUserResult([...data]);
    }

    const handleSubjectIconOnClick = () => {
        let data;
        if (nameAsc) {
            data = subjectResult.sort((a, b) => (a.firstName + " " + a.lastName).localeCompare(b.firstName + " " + b.lastName));
        } else {
            data = subjectResult.sort((a, b) => (b.firstName + " " + b.lastName).localeCompare(a.firstName + " " + a.lastName));
        }
        setNameAsc(!nameAsc);
        setSubjectResult([...data]);
    }

    const handleEmailIconOnClick = () => {
        let data;
        if (emailAsc) {
            data = userResult.sort((a, b) => a.email.localeCompare(b.email));
        } else {
            data = userResult.sort((a, b) => b.email.localeCompare(a.email));
        }
        setEmailAsc(!emailAsc);
        setUserResult([...data]);
    }

    const handleUserTypeAsc = () => {
        let data;
        if (userTypeAsc) {
            data = userResult.sort((a, b) => a.attributes.type[0].localeCompare(b.userType))
        }
        else {
            data = userResult.sort((a, b) => b.attributes.type[0].localeCompare(a.email))
        }
        setUserTypeAsc(!userTypeAsc);
        setUserResult([...data]);
    }

    const handleSerialNoIconOnClick = () => {
        let data;
        if (serialNoAsc) {
            data = deviceResult.sort((a, b) => a.attributes.serialnumber.localeCompare(b.attributes.serialnumber));
        } else {
            data = deviceResult.sort((a, b) => b.attributes.serialnumber.localeCompare(a.attributes.serialnumber));
        }
        setSerialNoAsc(!serialNoAsc);
        setDeviceResult([...data]);
    }

    const handleMacIdIconOnClick = () => {
        let data;
        if (macIdAsc) {
            data = deviceResult.sort((a, b) => a.attributes.macid.localeCompare(b.macid));
        } else {
            data = deviceResult.sort((a, b) => b.attributes.macid.localeCompare(a.macid));
        }
        setMacIdAsc(!macIdAsc);
        setDeviceResult([...data]);
    }

    //Auto Hide toast after 5 seconds
    const autoHideToast = (css, message) => {
        setToastClass(css);
        setMessage(message);
        setToastVisible(true);
        setTimeout(() => {
            setToastVisible(false);
        }, 6000);
    }

    return (
        <IonContent>
            <div className="search-box search-box-mob">
                {/* <IonItem className="search-input">
                    <IonItem className="filter" placeholder="Search by">
                        {(userFilterData.userFilters && userFilterData.userFilters.length > 0) ? userFilterData.userFilters.map((data) => {
                            return (<IonChip>
                                <IonLabel>{data.key + " " + data.value}</IonLabel>
                                <IonIcon icon={closeCircle}
                                         onClick={data.key === 'React' ? undefined : handleDeleteFilter(data, MODEL_TYPE_USER)}/>
                            </IonChip>)
                        }) : null}
                    </IonItem>

                </IonItem> */}
                <IonLabel className="table-heading">Search for Users</IonLabel>
                <IonIcon icon={search}
                    size="small"
                    className="search-icon"
                    onClick={e => !isAssigning && handleLoadUsers(true)} 
                    style={{ cursor: isAssigning ? 'not-allowed' : 'pointer', opacity: isAssigning ? 0.5 : 1 }} />
                <span
                    onMouseEnter={() => setIsVisible(true)}
                    onMouseLeave={() => setIsVisible(false)}
                    className="info-icon"
                >
                   &#128712;
                </span>
                {isVisible && <div className="tooltip">Click here to search for Patients</div>}
                {/* <IonIcon icon={optionsOutline}
                         className="filter-icon"
                         onClick={e => handleFilterOnClick(MODEL_TYPE_USER)}/> */}
            </div>


            <div>
                {isUserDataLoading ?
                    <div className="spinner-box">
                        <IonSpinner name="lines" className="ion-spinner" />
                        <IonLabel className="row-header">Please wait, search is in progress</IonLabel>
                    </div>
                    : <IonGrid className="container-grid">
                        <IonRow className="row-header">
                            <IonCol className="table-header-cell" >
                                <IonItem className="row-box">
                                    <IonInput value={name} placeholder="Name"
                                        onIonChange={handleNameOnChange} disabled={isAssigning}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' onClick={handleNameIconOnClick} />
                                </IonItem>
                            </IonCol>
                            <IonCol className="table-header-cell">
                                <IonItem className="row-box">
                                    <IonInput value={email} placeholder="Email Id"
                                        onIonChange={handleEmailOnChange} disabled={isAssigning}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' onClick={handleEmailIconOnClick} />
                                </IonItem>
                            </IonCol>
                            {/* <IonCol className="table-header-cell">
                                <IonItem className="row-box">
                                    <IonInput value={userTypeSearch} placeholder="User Type"
                                        onIonChange={handleUserTypeSearch}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' onClick={handleUserTypeAsc} />
                                </IonItem>
                            </IonCol> */}
                        </IonRow>
                        <IonLabel className='row-header'>Patient Selected: {userEmail}</IonLabel>
                        <PaginatedView userData={userResult}>
                            <UserTable onRadioChange={handleUserOnChange} disabled={isAssigning} />
                        </PaginatedView>
                    </IonGrid>}
            </div>
            <br/>
            {/* Search for enrolled subjectIds */}

            <div className="search-box search-box-mob">
                <IonLabel className="table-heading">Search for subjects</IonLabel>
                <IonIcon icon={search}
                    size="small"
                    className="search-icon"
                    onClick={e => !isAssigning && handleLoadSubjects(true)} 
                    style={{ cursor: isAssigning ? 'not-allowed' : 'pointer', opacity: isAssigning ? 0.5 : 1 }} />
            </div>

            <div>
                {isSubjectDataLoading ?
                    <div className="spinner-box">
                        <IonSpinner name="lines" className="ion-spinner" />
                        <IonLabel className="row-header">Please wait, search is in progress</IonLabel>
                    </div>
                    : <IonGrid className="container-grid">
                        <IonRow className="row-header">
                            <IonCol className="table-header-cell" >
                                <IonItem className="row-box">
                                    <IonInput value={subjectId} placeholder="SubjectId"
                                        onIonChange={handleSubjectOnChange} disabled={isAssigning}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' onClick={handleSubjectIconOnClick} />
                                </IonItem>
                            </IonCol>
                            <IonCol></IonCol>
                        </IonRow>
                        <IonLabel className='row-header'>Subject Selected: {subjectId}</IonLabel>
                        <PaginatedView userData={subjectResult}>
                            <SubjectIdTable onRadioChange={handleSubjectOnChange} disabled={isAssigning} />
                        </PaginatedView>
                    </IonGrid>}
            </div>
            
            <br/>
            <div className="search-box">
                <IonLabel className="table-heading">Search for Devices</IonLabel>
                <IonIcon icon={search}
                    size="small"
                    className="search-icon"
                    onClick={e => !isAssigning && handleLoadDevices(true)} 
                    style={{ cursor: isAssigning ? 'not-allowed' : 'pointer', opacity: isAssigning ? 0.5 : 1 }} />
                {/* <IonIcon icon={optionsOutline}
                         className="filter-icon"
                         onClick={e => handleFilterOnClick(MODEL_TYPE_DEVICE)}/> */}
            </div>
            
            {/* Search for enrolled subjectIds */}

            <div>
                {isDeviceDataLoading ?
                    <div className="spinner-box">
                        <IonSpinner name="lines" className="ion-spinner" />
                        <IonLabel className="row-header">Please wait, search is in progress</IonLabel>
                    </div>
                    : <IonGrid className="container-grid">
                        <IonRow className="row-header">
                            <IonCol className="table-header-cell">
                                <IonItem className="row-box">
                                    <IonInput value={serialNo} placeholder="Serial Number"
                                        onIonChange={handleSerialNoOnChange} disabled={isAssigning}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' onClick={handleSerialNoIconOnClick} />
                                </IonItem>
                            </IonCol>
                            <IonCol className="table-header-cell">
                                <IonItem className="row-box">
                                    <IonInput value={macId} placeholder="Mac Id"
                                        onIonChange={handleMacIdOnChange} disabled={isAssigning}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' onClick={handleMacIdIconOnClick} />
                                </IonItem>
                            </IonCol>
                            <IonCol></IonCol>
                        </IonRow>
                        <IonLabel className='row-header'>Device Selected: {deviceNum}</IonLabel>
                        <PaginatedView userData={deviceResult}>
                            <DeviceTable onRadioChange={handleDeviceOnChange} disabled={isAssigning} />
                        </PaginatedView>
                    </IonGrid>}
            </div>

            <br/>
            {/* Search for Chargers */}
            <div className="search-box search-box-mob">
                <IonLabel className="table-heading">Search for Chargers</IonLabel>
                <IonIcon icon={search}
                    size="small"
                    className="search-icon"
                    onClick={e => !isAssigning && !isPairing && handleLoadChargers()}
                    style={{ cursor: (isAssigning || isPairing) ? 'not-allowed' : 'pointer', opacity: (isAssigning || isPairing) ? 0.5 : 1 }} />
            </div>

            <div>
                {isChargerDataLoading ?
                    <div className="spinner-box">
                        <IonSpinner name="lines" className="ion-spinner" />
                        <IonLabel className="row-header">Please wait, search is in progress</IonLabel>
                    </div>
                    : <IonGrid className="container-grid">
                        <IonRow className="row-header">
                            <IonCol className="table-header-cell">
                                <IonItem className="row-box">
                                    <IonInput value={chargerSerialFilter} placeholder="Serial Number"
                                        onIonChange={handleChargerSerialFilter} disabled={isAssigning || isPairing}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' />
                                </IonItem>
                            </IonCol>
                            <IonCol className="table-header-cell">
                                <IonItem className="row-box">
                                    <IonInput value={chargerMacFilter} placeholder="Charger Mac Id"
                                        onIonChange={handleChargerMacFilter} disabled={isAssigning || isPairing}></IonInput>
                                    <IonIcon icon={filterOutline} slot='end' />
                                </IonItem>
                            </IonCol>
                            <IonCol className="table-header-cell" style={{ maxWidth: '100px' }}>
                                <IonLabel>Status</IonLabel>
                            </IonCol>
                            <IonCol className="table-header-cell">
                                <IonLabel>Paired IPG</IonLabel>
                            </IonCol>
                        </IonRow>
                        <IonLabel className='row-header'>Charger Selected: {chargerSerialNum}</IonLabel>
                        <PaginatedView userData={chargerResult}>
                            <ChargerTable onRadioChange={handleChargerOnChange} disabled={isAssigning || isPairing} />
                        </PaginatedView>
                    </IonGrid>}
            </div>

            <div className="assign-toast-host">
                {
                    toastVisible && <div className={toastClass}> {message} </div>
                }
            </div>

            <IonButton className="assign-button" disabled={!(userId && deviceMacId) || isAssigning} onClick={handleAssignDevice}>
                {isAssigning ? <IonSpinner name="crescent" /> : 'Assign Device'}
            </IonButton>
            <IonButton className="assign-button" disabled={!(userId && deviceMacId) || isAssigning} onClick={handleUnAssignDevice}>Unassign
                Device</IonButton>
            <IonButton className="assign-button" disabled={!(userId && userType === 'patient' && subjectId) || isAssigning} onClick={handleMapSubject}>Map
                Subject</IonButton>
            <IonButton className="assign-button" disabled={!(deviceMacId && chargerMacId) || isPairing || isAssigning} onClick={handleAssignCharger}>
                {isPairing ? <IonSpinner name="crescent" /> : 'Assign Charger'}
            </IonButton>
        </IonContent>
    );
};
export default AssignDevice;